import React, { Component } from 'react'
import $ from 'jquery'

export default class CustomService extends Component {
    render() {
        return (
            <div id="partnerfaq_customservice" className="panel">
                Custom Service
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/partnerfaqs/customService/index.js